import React, { useState } from 'react';
import StatusIndicator from './StatusIndicator';

const WaitingRoom = ({ gameId, onBackToLobby, connectionStatus, playerName }) => {
  const [copied, setCopied] = useState(false);

  const copyGameCode = async () => {
    try {
      await navigator.clipboard.writeText(gameId);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy game code:', err);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-white mb-2">🃏 Last Card</h1>
          <p className="text-gray-400 mb-4">Waiting for opponent...</p>
          {playerName && (
            <p className="text-blue-400 font-semibold">Welcome, {playerName}!</p>
          )}
          
          {/* Connection Status */}
          <div className="flex items-center justify-center mb-6">
            <StatusIndicator status={connectionStatus} />
          </div>
        </div>

        {/* Game Code Section */}
        <div className="bg-gray-800 rounded-xl p-6 shadow-2xl mb-6">
          <h2 className="text-2xl font-semibold text-white mb-4 text-center">
            Share Game Code
          </h2>
          
          <div className="bg-gray-700 rounded-lg p-4 mb-4">
            <div className="text-center">
              <div className="text-3xl font-mono font-bold text-blue-400 mb-2">
                {gameId}
              </div>
              <p className="text-gray-400 text-sm">
                Share this code with your friend to join the game
              </p>
            </div>
          </div>

          <button
            onClick={copyGameCode}
            className="w-full btn btn-primary text-lg py-3 mb-4"
          >
            {copied ? '✅ Copied!' : '📋 Copy Game Code'}
          </button>

          <div className="text-center">
            <div className="animate-pulse">
              <div className="text-yellow-400 text-lg mb-2">⏳ Waiting for opponent...</div>
              <div className="flex justify-center space-x-2">
                <div className="w-2 h-2 bg-yellow-400 rounded-full animate-bounce"></div>
                <div className="w-2 h-2 bg-yellow-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
                <div className="w-2 h-2 bg-yellow-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
              </div>
            </div>
          </div>
        </div>

        {/* Instructions */}
        <div className="bg-gray-800 rounded-xl p-6">
          <h3 className="text-lg font-semibold text-white mb-4">📱 How to Join</h3>
          <div className="space-y-3 text-sm text-gray-300">
            <div className="flex items-start space-x-3">
              <div className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold mt-0.5">1</div>
              <p>Open Last Card in another browser tab or device</p>
            </div>
            <div className="flex items-start space-x-3">
              <div className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold mt-0.5">2</div>
              <p>Click "Join Existing Game"</p>
            </div>
            <div className="flex items-start space-x-3">
              <div className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold mt-0.5">3</div>
              <p>Enter the game code above</p>
            </div>
            <div className="flex items-start space-x-3">
              <div className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold mt-0.5">4</div>
              <p>Click "Join Game" to start playing!</p>
            </div>
          </div>
        </div>

        {/* Back to Lobby Button */}
        <div className="mt-6 text-center">
          <button
            onClick={onBackToLobby}
            className="btn btn-secondary"
          >
            ← Back to Lobby
          </button>
        </div>
      </div>
    </div>
  );
};

export default WaitingRoom; 